import { apiClient } from 'container/apiClient';
import { ProjectScoreApi } from 'api/ProjectScoreApi';
import { engagementScoreMapper } from 'container/engagementScoreMapper';
import { summaryMapper } from 'container/summaryMapper';

export const projectScoreApi = new ProjectScoreApi(apiClient, engagementScoreMapper, summaryMapper);
